import { useDocumentData } from 'features/libra/document/DocumentDataContext'
import { useDocumentUI } from 'features/libra/document/DocumentUIContext'
import { DocumentNavigationSidebar } from 'features/libra/stepComponents/niiDataHealth/DocumentNavigationSidebar'
import { FC } from 'react'

interface DocumentNavigationSidebarContainerProps {
  unitId: string
  onUploadComplete?: (documentIds: ReadonlyArray<string>) => void
  showUploader?: boolean
}

/**
 * Container component that connects the generic DocumentNavigationSidebar
 * to the DocumentNavigationContext. This separates concerns and makes
 * the sidebar reusable across different workflows.
 */
export const DocumentNavigationSidebarContainer: FC<
  DocumentNavigationSidebarContainerProps
> = ({ unitId, onUploadComplete, showUploader = false }) => {
  // Separate data and UI concerns
  const {
    metricsByCategory,
    documentsByCategory,
    isLoading,
    forceRefresh,
    requiredCategories,
  } = useDocumentData()

  const { selectedCategory, setSelectedCategory } = useDocumentUI()

  // Combine all categories (required + those with documents)
  const allCategories = Array.from(
    new Set([...requiredCategories, ...metricsByCategory.keys()])
  )

  return (
    <DocumentNavigationSidebar
      unitId={unitId}
      onUploadComplete={onUploadComplete}
      showUploader={showUploader}
      categories={allCategories}
      requiredCategories={requiredCategories}
      metricsByCategory={metricsByCategory}
      documentsByCategory={documentsByCategory}
      isLoading={isLoading}
      onRefresh={forceRefresh}
      selectedCategory={selectedCategory}
      onCategorySelect={setSelectedCategory}
    />
  )
}
